import styled from "styled-components";
import Label from "../label/label.component.js";
export const SectionTitleContainer = styled(Label).withConfig({
  displayName: "section-titlestyles__SectionTitleContainer",
  componentId: "sc-g5sivy-0"
})(["", ""], {
  display: "flex",
  textAlign: "center"
});
